import { render, staticRenderFns } from "./NavigationBar.vue?vue&type=template&id=246516a7&scoped=true&"
import script from "./NavigationBar.vue?vue&type=script&lang=ts&"
export * from "./NavigationBar.vue?vue&type=script&lang=ts&"
import style0 from "./NavigationBar.vue?vue&type=style&index=0&id=246516a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246516a7",
  null
  
)

export default component.exports